export default "__VITE_ASSET__0237816a__"